export const difficultyBadgeSize = {
    small: 'small',
    large: 'large',
};
